exports = function(val) {
    return !!(val && val.nodeType === 1);
};

module.exports = exports;
